// RigSentinel Context Engine — bootstrap.
//
// Wires the dependency-injection seams used to break circular imports
// between the resolver and modules that need to call into it (e.g.
// `lib/mud/dmr.js` freezes a context snapshot via `resolve(...)`).
//
// Importing this module once at app startup is sufficient.

import { resolve } from "./resolver";
import { _setResolver as setMudResolver } from "@/lib/mud/dmr";
import { _setResolver as setKsResolver } from "@/lib/killsheet/storage";

setMudResolver(resolve);
setKsResolver(resolve);
